export default __webpack_public_path__ + "static/media/3.28d76576.png";